export interface Props {
  subTotal: number;
  vat: number;
  totalAmount: number;
  currency: string;
}

export function PriceTotal({ subTotal, vat, totalAmount, currency }: Props) {
  return (
    <div className={"w-full text-sm space-y-2 my-5 pr-4"}>
      <div className={"grid grid-cols-9 border-b pb-3"}>
        <div className={"col-span-7"}></div>
        <p className={"capitalize justify-self-end col-span-1"}>subtotal</p>
        <p className={"justify-self-end col-span-1"}>
          {currency} {subTotal.toFixed(2)}
        </p>
      </div>
      <div className={"grid grid-cols-9 border-b pb-3"}>
        <div className={"col-span-7"}></div>
        <p className={"uppercase justify-self-end col-span-1"}>vat</p>
        <p className={"justify-self-end col-span-1"}>
          {currency} {vat.toFixed(2)}
        </p>
      </div>
      <div className={"grid grid-cols-9 font-bold"}>
        <div className={"col-span-7"}></div>
        <p className={"capitalize justify-self-end col-span-1"}>total amount</p>
        <p className={"justify-self-end col-span-1"}>
          {currency} {totalAmount.toFixed(2)}
        </p>
      </div>
    </div>
  );
}
